import img from "../../../img/trandvich.webp";
export const cardNews = [
  {
    img: img ,
    name: "Trendvich",
    text: "Trendwich Toaster bun, mayonnaise, iceberg lettuce leaf,1 piece tomato and chicken schnitzel",
    price: "30 000 sum",
  },
  {
    img:  img ,
    name: "Maxi BOX Trendvich",
    text: "Trendvich, fries, 0.4 l coca cola, sauce to choose from",
    price: "45 000 sum",
  },
];
